import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    getPesquisasSatisfacaoBox(context, filtros) {
        filtros.componente = "SearchBoxPesquisasSatisfacao";
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("pesquisasSatisfacao/access/listaBox", filtros).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getPesquisaSatisfacao(context, idPesquisaSatisfacao) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("pesquisasSatisfacao/access/obter", { ID_PESQUISA_SATISFACAO: idPesquisaSatisfacao }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};